import React from "react"

import styles from "./styles.module.scss"

const HeaderNeat = ({ title, instructions }) => {
  return (
    <header className={styles.container}>
      <h3>{title}</h3>
      <p>{instructions}</p>
    </header>
  )
}

export default HeaderNeat
